import styled from 'styled-components'
import { breakpoints } from '../../constants/theme'

const Spacer = styled.div`
  padding: ${({ size }) => (size ? `${size * 30}px 0` : '30px 0')};
  @media ${breakpoints.tablet} {
    padding: ${({ size }) => (size ? `${size * 15}px 0` : '15px 0')};
  }
`

export default Spacer
